import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function masters() {
  const response = await http
    .getData("/skrining-bunuh-diri/masters")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function create(data: any) {
  const response = await http
    .postData("/skrining-bunuh-diri", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/skrining-bunuh-diri/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/skrining-bunuh-diri`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function timeline(pasienRm: string | number) {
  const response = await http
    .getData(`/skrining-bunuh-diri/by-pasien/${pasienRm}/timeline`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function find(id: number) {
  const response = await http
    .getData(`/skrining-bunuh-diri/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/skrining-bunuh-diri/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function sign(id: number, data: { role: string; password: string }) {
  const response = await http
    .postData(`/skrining-bunuh-diri/${id}/sign`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function markTindakLanjut(
  id: number,
  tlId: number,
  data: { status?: string; catatan_pelaksanaan?: string }
) {
  const response = await http
    .postData(`/skrining-bunuh-diri/${id}/tindak-lanjut/${tlId}/mark`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function aktivasiCodeBlue(id: number) {
  const response = await http
    .postData(`/skrining-bunuh-diri/${id}/aktivasi-code-blue-psikiatri`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/skrining-bunuh-diri/${id}/pdf`, "_blank");
}

export default {
  masters,
  create,
  update,
  getByRegister,
  timeline,
  find,
  destroy,
  sign,
  markTindakLanjut,
  aktivasiCodeBlue,
  printPdf
};
